import { useEffect, useState } from "react";

import {
  DatePicker,
  LoadingShimmer,
  useDatePickerHelpers,
} from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import { useScheduleAssign } from "@/assignments/useScheduleAssign/useScheduleAssign";
import {
  dateTimeSelectorInputCss,
  dateTimeSelectorCSS,
  popOutCss,
  dateTimeSelectorLoadingWrapperCss,
} from "./ScheduledDateTimeInput.style";

const propTypes = {
  /* Local DateTime String */
  max: PropTypes.string,
  /* Local DateTime String */
  scheduledDateTime: PropTypes.string,
  /* Function that should be called when Selected date changes */
  onScheduledDateTimeChange: PropTypes.func,
  /* Parent component can control whether or not ScheduledDateInput should appear as loading */
  isLoading: PropTypes.bool,
  /* Determines if the editor is in editing mode */
  isEditingExistingAssignment: PropTypes.bool,
  /* Local DateTime String */
  originalDateGoesLive: PropTypes.string,
};
const ScheduledDateInput = ({
  max: maxScheduleDate,
  scheduledDateTime: dateGoesLive,
  onScheduledDateTimeChange,
  isLoading,
  isEditingExistingAssignment,
  originalDateGoesLive,
}) => {
  const { getIsoDateValue } = useDatePickerHelpers();

  const { scheduledDateTime, minValue, resetDate, maxValueAttribute } =
    useScheduleAssign({ dateGoesLive, originalDateGoesLive, maxScheduleDate });

  const [value, setValue] = useState(scheduledDateTime);

  useEffect(() => {
    if (!value) return;

    if (value >= minValue) {
      // `value` in local state should always be Aria Date object however we store ISO String in Assignment Reducer / Assignments API
      // onChange(isoDateString);
      const isoDateString = getIsoDateValue(value);
      onScheduledDateTimeChange(isoDateString);
    }
  }, [value]);

  if (
    isLoading ||
    (isEditingExistingAssignment && typeof originalDateGoesLive === "undefined")
  ) {
    return (
      <div css={dateTimeSelectorLoadingWrapperCss}>
        <LoadingShimmer />
      </div>
    );
  }

  return (
    <div css={dateTimeSelectorCSS}>
      <DatePicker
        calendarActionButton={{
          content: "Reset",
          onPress: () => setValue(resetDate),
          shouldCloseOnPress: false,
        }}
        label={
          isEditingExistingAssignment ? "Schedule for" : "Schedule for later"
        }
        dataProps={{ "data-qa-selector": "scheduling_assignment" }}
        minValue={minValue}
        {...maxValueAttribute}
        onChange={setValue}
        timeField={{
          label: "Time",
        }}
        value={value}
        __cssFor={{
          ...dateTimeSelectorInputCss,
          PopOut: popOutCss,
        }}
      />
    </div>
  );
};

ScheduledDateInput.propTypes = propTypes;

export default withTrackEvent(ScheduledDateInput);
